import * as types from './types';

const fetchArchetypeSuccess = data => ({
  type: types.GENERAL_REPORT_ARCHETYPE_FETCH_SUCCESS,
  payload: {
    columns: data.columns
  }
});

const startFetch = () => ({
  type: types.GENERAL_REPORT_DATA_FETCH_START
});

const fetchSuccessful = (data, _, loadingStatus) => ({
  type: types.GENERAL_REPORT_DATA_FETCH_SUCCESS,
  payload: {
    loadingStatus,
    data
  }
});

const setDownloadProgress = progress => ({
  type: types.GENERAL_REPORT_DATA_DOWNLOAD_PROGRESS_UPDATE,
  payload: {
    progress
  }
});

const fetchFailed = error => ({
  type: types.GENERAL_REPORT_DATA_FETCH_FAILED,
  payload: {
    error
  }
});

const clearData = () => ({
  type: types.GENERAL_REPORT_DATA_CLEAR
});

export default {
  fetchArchetypeSuccess,
  startFetch,
  fetchSuccessful,
  fetchFailed,
  clearData,
  setDownloadProgress
};
